import * as React from 'react';

import i18n from 'helper/i18n';
import appConfig from 'helper/mapBackendConfig';

import Link from 'components/atoms/Link';

export default function leaveCoach() {
	return (
		<Link
			title={i18n('react.impulsCoach.components.anamnesis.leaveCoachCaption')}
			iconRight={'arrow-right'}
			externalHref={appConfig.env.migrosImpulsCoachLandingPage.href}
			openInNewWindow={appConfig.env.migrosImpulsCoachLandingPage.openInNewWindow}
		/>
	);
}
